import Marquee from "react-fast-marquee";
import { LogoMark } from "@/components/Logo";

const ITEMS = [
  "Business Websites",
  "Web Applications",
  "AI Solutions",
  "E-Commerce",
  "Landing Pages",
  "Website Redesign",
  "Maintenance",
  "SEO",
  "Digital Growth",
];

export default function EditorialMarquee() {
  return (
    <div className="border-y border-white/10 bg-[#070B16] py-7" data-testid="marquee-strip" aria-hidden="true">
      <Marquee speed={22} gradient={false} pauseOnHover>
        {ITEMS.map((item) => (
          <span key={item} className="mx-8 flex items-center gap-8">
            <span className="font-display text-lg font-bold uppercase tracking-[0.3em] text-white/20">
              {item}
            </span>
            <span className="opacity-30">
              <LogoMark size={18} />
            </span>
          </span>
        ))}
      </Marquee>
    </div>
  );
}
